export enum Mode {
  full = 'full',
  preview = 'preview',
}
